import React from "react";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";

import { Block } from "../../atoms/Layout/Block/Block";
import { Text } from "../../atoms/Text/Text";
import { Game } from "../../models/Game";
import Search from "../../molecules/Search/Search";
import styles from "./Annoucment.css";

type AnnouncementTemplateProps = {
  games: Game[];
  gameData: any;
};

export class AnnouncementTemplate extends React.PureComponent<AnnouncementTemplateProps> {
  render() {
    const { games, gameData } = this.props;

    const meta = [];
    const link = [];

    if (gameData.robots) {
      meta.push({ name: "robots", content: "noindex, follow" });
    }

    if (gameData.metaDescription) {
      meta.push({ name: "description", content: gameData.metaDescription });
    }

    if (gameData.canonical) {
      link.push({ rel: "canonical", href: gameData.canonical });
    }

    return (
      <Overlay>
        <Helmet title={gameData.name} meta={meta} link={link} />

        <GlobalStyles />
        <Popup>
          <Text1stBlock>
            <Text size="h1" align="center">
              👷‍
            </Text>
          </Text1stBlock>

          <Block paddingB="x3l">
            <Text1st bold={true} size="h3" align="center">
              "OOPS!"
            </Text1st>
          </Block>

          <Block paddingB="x3l">
            <Dash />
          </Block>

          <Block paddingB="x3l">
            <Text2nd bold={true} size="h1" align="center">
              {gameData.name} {gameData.first}
            </Text2nd>
          </Block>

          <Block>
            <Text3rd>{gameData.last}</Text3rd>
          </Block>

          <Block paddingB="x4l">
            {gameData.games.map((item, ind) => (
              <Text3rd key={ind}>
                <Link to={Game.getURLAlias(item.game)}>
                  {item.game.seo_GameName}
                </Link>
              </Text3rd>
            ))}
          </Block>

          <PlayLink to="/category/all-games">
            <Text bold={true} size="lg" align="center">
              SEE ALL GAMES
            </Text>
          </PlayLink>

          <SearchBox games={games} placeholder="Or search here..." />
        </Popup>
      </Overlay>
    );
  }
}

const Overlay = (props: any) => <div className={styles.overlay} {...props} />;
const Popup = (props: any) => <div className={styles.popup} {...props} />;
const PlayLink = (props: any) => (
  <RouterLink className={styles.playLink} {...props} />
);
const Dash = (props: any) => <div className={styles.dash} {...props} />;
const Text1stBlock = (props: any) => (
  <div className={styles.text1stBlock} {...props} />
);
const Text1st = (props: any) => <Text className={styles.text1st} {...props} />;
const Text2nd = (props: any) => <Text className={styles.text2nd} {...props} />;
const Text3rd = (props: any) => <div className={styles.Text3rd} {...props} />;
const SearchBox = (props: any) => (
  <Search className={styles.searchBox} {...props} />
);
const Link = (props: any) => <RouterLink className={styles.link} {...props} />;

const GlobalStyles = (props: any) => (
  <style>
    {`
            body {
                background-image:  url('/Pattern.png');
            }

            [data-header="true"] {
                display:  none !important;
            }
        `}
  </style>
);
